/* Xsecret own 2-Year Extended Warranty v3 - vanilla, no deps.
   Intent is carried on the item itself: the PDP checkbox is a real form field (properties[_xs_wty]=1),
   so whoever submits the form (theme AJAX, native POST, an app) the cart line remembers the choice.
   Reconcile then adds/keeps the warranty line for every flagged item. "0" = customer removed it. */
(function () {
  'use strict';
  var HANDLE = 'extended-warranty-2-years', PID = 9791723438319, MAX = 600, FLAG = '_xs_wty';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ts = window.themeVariables && themeVariables.settings;
  var isCartPage = !!(ts && ts.pageType === 'cart');
  var cartTypePage = !!(ts && ts.cartType === 'page');
  var map = null, busy = false;
  function log() { try { console.info.apply(console, ['[xs-wty]'].concat([].slice.call(arguments))); } catch (e) {} }

  function post(url, body) {
    return fetch(root + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { log('fail', url, r.status, j && (j.description || j.message)); throw j; } return j; }); });
  }
  function getCart() { return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function getMap() {
    if (map) return Promise.resolve(map);
    var w = window.xsWtyMap;
    if (w && Object.keys(w).length) { map = w; return Promise.resolve(map); }
    return fetch(root + 'products/' + HANDLE + '.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (p) {
      var m = {};
      p.variants.forEach(function (v) { if (v.available) m[Math.round(v.price / 100)] = v.id; });
      if (Object.keys(m).length) map = m;
      return m;
    });
  }
  function tier(cents) {
    var n = Math.max(1, Math.ceil(Math.round(cents) / 1000));
    if (n > 200) n = Math.ceil(n / 10) * 10;
    return n > MAX ? 0 : n;
  }
  function wVariant(m, cents) { var n = tier(cents); if (!n) return null; while (n <= MAX && !m[n]) n++; return m[n] || null; }
  function isW(it) { return it.product_id === PID || it.handle === HANDLE; }
  function flag(it) { return it.properties && it.properties[FLAG] != null ? String(it.properties[FLAG]) : ''; }
  function covered(cart) {
    var c = {};
    cart.items.forEach(function (it) {
      if (isW(it)) return;
      var k = String(it.variant_id), o = c[k] || (c[k] = { qty: 0, price: it.price, want: false, title: it.product_title + (it.variant_title ? ' - ' + it.variant_title : '') });
      o.qty += it.quantity; o.price = Math.max(o.price, it.price);
      if (flag(it) === '1') o.want = true;
    });
    return c;
  }
  function refresh(cart) {
    if (isCartPage) { location.reload(); return; }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (cart) document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, xsWty: true } }));
  }

  /* Make the cart match intent: one warranty line per covered variant, qty = all units of it,
     right price tier; drop orphans; ADD for flagged items that have none. Resolves true if changed. */
  function sync(cart) {
    var ws = cart.items.filter(isW), cov = covered(cart);
    var wanted = Object.keys(cov).filter(function (k) { return cov[k].want; });
    if (!ws.length && !wanted.length) return Promise.resolve(false);
    return getMap().then(function (m) {
      var seen = {}, upd = {}, adds = [], n = 0;
      ws.forEach(function (l) {
        var f = l.properties && l.properties._xs_for ? String(l.properties._xs_for) : '', c = cov[f];
        if (!c || seen[f]) { upd[l.key] = 0; n++; return; }
        seen[f] = 1;
        var vid = wVariant(m, c.price);
        if (!vid) { upd[l.key] = 0; n++; return; }
        if (vid !== l.variant_id) { upd[l.key] = 0; n++; adds.push({ id: vid, quantity: c.qty, properties: { 'Covers': c.title, '_xs_for': f } }); }
        else if (l.quantity !== c.qty) { upd[l.key] = c.qty; n++; }
      });
      wanted.forEach(function (f) {
        if (seen[f]) return;
        var vid = wVariant(m, cov[f].price);
        if (vid) { adds.push({ id: vid, quantity: cov[f].qty, properties: { 'Covers': cov[f].title, '_xs_for': f } }); n++; }
      });
      if (!n) return false;
      log('sync', upd, adds);
      var p = Object.keys(upd).length ? post('cart/update.js', { updates: upd }) : Promise.resolve();
      return p.then(function () { return adds.length ? post('cart/add.js', { items: adds }) : null; }).then(function () { return true; });
    });
  }
  function syncAndRefresh(cart) {
    if (busy) return Promise.resolve();
    busy = true;
    return sync(cart).then(function (changed) {
      if (!changed) return;
      return getCart().then(refresh);
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* Set the flag on every line of a variant (one change at a time: keys change when properties change) */
  function setFlag(variantId, val, d) {
    d = d || 0; if (d > 10) return Promise.resolve();
    return getCart().then(function (cart) {
      var idx = -1;
      cart.items.some(function (it, i) { if (!isW(it) && String(it.variant_id) === variantId && flag(it) !== val) { idx = i; return true; } });
      if (idx < 0) return;
      var it = cart.items[idx], props = {};
      Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
      props[FLAG] = val;
      return post('cart/change.js', { line: idx + 1, quantity: it.quantity, properties: props }).then(function () { return setFlag(variantId, val, d + 1); });
    });
  }

  /* Cart toggle / warranty-line remove: on = flag 1 + add; off = flag 0 + remove */
  function setWarranty(variantId, on) {
    variantId = String(variantId);
    return setFlag(variantId, on ? '1' : '0').then(getCart).then(function (cart) {
      if (on) return sync(cart);
      var u = {}, n = 0;
      cart.items.forEach(function (l) { if (isW(l) && l.properties && String(l.properties._xs_for) === variantId) { u[l.key] = 0; n++; } });
      return n ? post('cart/update.js', { updates: u }) : null;
    });
  }

  /* Product page fast path: add item (with flag) + warranty, then go to cart / open drawer.
     If anything here fails or never runs, the flag on the item still makes the cart add the warranty. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var fid = form && form.getAttribute && form.getAttribute('id');
    if (!fid || !form.matches('form[action*="/cart/add"]')) return;
    var box = document.querySelector('[data-xs-wty-pdp][data-form-id="' + fid + '"]');
    var cb = box && box.querySelector('[data-xs-wty-cb]');
    if (!cb || !cb.checked || box.hidden) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = e.submitter || form.querySelector('[type="submit"]'); if (btn) btn.setAttribute('aria-busy', 'true');
    busy = true;
    var fd = new FormData(form); fd.set('properties[' + FLAG + ']', '1');
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return getCart().then(sync); })
      .then(function () {
        busy = false;
        if (cartTypePage || isCartPage) { location.href = root + 'cart'; return; }
        return getCart().then(function (cart) {
          if (btn) btn.removeAttribute('aria-busy');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, xsWty: true } }));
        });
      })
      .catch(function (err) {
        busy = false; log('pdp add failed, falling back', err);
        if (btn) btn.removeAttribute('aria-busy');
        if (err && err.status === 422) { HTMLFormElement.prototype.submit.call(form); return; }
        location.href = root + 'cart'; /* item may already be in; cart page reconcile adds warranty */
      });
  }, true);
  /* Variant change: re-price, hide (and untick) when not eligible */
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant; if (!v) return;
    document.querySelectorAll('[data-xs-wty-pdp]').forEach(function (box) {
      var t = tier(v.price);
      box.hidden = !t;
      var cb = box.querySelector('[data-xs-wty-cb]'); if (cb) cb.disabled = !t;
      var p = box.querySelector('[data-xs-wty-price]'); if (p && t) p.textContent = 'RM' + t;
    });
  });

  /* Cart drawer + cart page toggle */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-xs-wty-toggle]')) return;
    t.disabled = true; busy = true;
    setWarranty(t.getAttribute('data-variant'), t.checked)
      .then(function () { busy = false; return getCart().then(refresh); })
      .catch(function () { busy = false; return getCart().then(refresh); });
  });
  /* "Remove" on a warranty line = untick (so it is not re-added) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.xs-wty-line a[href*="/cart/change"], .xs-wty-line .line-item__remove-button');
    if (!a) return;
    var row = a.closest('.xs-wty-line'), f = row && row.getAttribute('data-xs-for');
    if (!f) return;
    e.preventDefault(); e.stopImmediatePropagation(); busy = true;
    setWarranty(f, false).then(function () { busy = false; return getCart().then(refresh); }, function () { busy = false; return getCart().then(refresh); });
  }, true);

  /* Drawer qty changes / any theme cart update -> keep warranty in step */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.xsWty) return;
    var cart = e.detail && e.detail.cart;
    if (cart && cart.items) syncAndRefresh(cart);
  });

  /* Cart page: native qty change is a full navigation; do item + warranty in one go */
  if (isCartPage) {
    var cartChange = function (line, qty) {
      busy = true;
      return post('cart/change.js', { line: line, quantity: qty }).then(sync).then(function () { location.reload(); }, function () { location.reload(); });
    };
    var hasW = function () { return !!document.querySelector('.xs-wty-line, [data-xs-wty-toggle]:checked'); };
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('line-item-quantity a[href*="/cart/change"]');
      if (!a || !hasW()) return;
      var u = new URL(a.href, location.href), line = parseInt(u.searchParams.get('line'), 10), q = parseInt(u.searchParams.get('quantity'), 10);
      if (!line || isNaN(q)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      cartChange(line, q);
    }, true);
    document.addEventListener('change', function (e) {
      var i = e.target;
      if (!i.matches || !i.matches('line-item-quantity input[data-line]') || !hasW()) return;
      e.stopImmediatePropagation();
      cartChange(parseInt(i.getAttribute('data-line'), 10), parseInt(i.value, 10) || 0);
    }, true);
  }

  /* Every page load: reconcile once (adds warranty for flagged items, fixes qty, drops orphans) */
  var run = function () {
    var k = 'xsWtyReload', c = +(sessionStorage.getItem(k) || 0);
    getCart().then(function (cart) {
      if (!cart.items.some(function (it) { return isW(it) || flag(it) === '1'; })) return false;
      return sync(cart).then(function (ch) {
        if (!ch) return false;
        if (isCartPage) { if (c < 2) { sessionStorage.setItem(k, c + 1); location.reload(); } return true; }
        return getCart().then(refresh).then(function () { return true; });
      });
    }).then(function (ch) { if (!ch) sessionStorage.removeItem(k); }).catch(function () {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
